import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';
import VueI18n from 'vue-i18n';

import customIcons from '../icons';
import vuetifyCS from '../locale/cs';

Vue.use(Vuetify);
Vue.use(VueI18n);

const messages = {
  cs: { $vuetify: vuetifyCS },
};

const i18n = new VueI18n({
  locale: 'cs',
  messages,
});

window.translateWorker = i18n;

export default new Vuetify({
  icons: {
    iconfont: 'faSvg',
    values: customIcons,
  },
  lang: { t: (key, ...params) => i18n.t(key, params) },
  theme: {
    themes: {
      light: {
        primary: colors.deepPurple,
        blue: colors.deepPurple,
      },
    },
  },
});
